import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function HowItWorksSection() {
  const steps = [
    {
      icon: 'ri-user-add-line',
      title: 'Create Account',
      description: 'Sign up with your email or phone number and get verified with our secure KYC process.',
      color: 'bg-blue-100 text-blue-600'
    },
    {
      icon: 'ri-camera-line',
      title: 'Post Your Ad',
      description: 'Upload photos, add details, and set your price. Our AI helps optimize your listing.',
      color: 'bg-green-100 text-green-600'
    },
    {
      icon: 'ri-chat-3-line',
      title: 'Connect & Chat',
      description: 'Buyers contact you directly through our secure in-app messaging system.',
      color: 'bg-purple-100 text-purple-600'
    },
    {
      icon: 'ri-secure-payment-line',
      title: 'Secure Payment',
      description: 'Complete transactions safely with our escrow service and get paid securely.',
      color: 'bg-orange-100 text-orange-600'
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            How ListIt Works
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Buying and selling on ListIt is simple, secure, and straightforward
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="relative mb-6">
                <div className={`w-16 h-16 ${step.color} rounded-full flex items-center justify-center mx-auto mb-4`}>
                  <i className={`${step.icon} text-2xl`}></i>
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-gray-900 text-white rounded-full flex items-center justify-center text-sm font-bold">
                  {index + 1}
                </div>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {step.title}
              </h3>
              <p className="text-gray-600">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/signup">
            <Button variant="primary" size="lg" className="px-8">
              Get Started Today
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}